export function downloadBlob(blob: Blob, filename: string): void {
    const objectUrl = window.URL.createObjectURL(blob);
    try {
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } finally {
        window.URL.revokeObjectURL(objectUrl);
    }
}
